import { useEffect, useState } from "react"
import { getAllRoles } from "../../service/AdminService/userService";
const useRoles =()=> {
    const [roles, setRoles] = useState();
    useEffect(()=> {
        fetchRoles();
    },[])
    const fetchRoles = async()=> {
        const response = await getAllRoles();
        setRoles(response.resp.data);
    } 
    return {roles}
}
export default useRoles;


